import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { type CustomUser } from 'api';
import { UsersService } from 'services';

const useGetFirmUsers = (firmId?: number, userSearchValue?: string) => {
  const getFirmUsers = async () => {
    const usersService = new UsersService();
    const firmUsers = await usersService.getUsers(firmId);
    if (!firmUsers) throw new Error('An error occurred while retrieving firm users');
    return firmUsers;
  };

  const { data, isLoading, error } = useQuery({
    enabled: !!firmId,
    queryKey: ['firmUsers', firmId],
    queryFn: () => getFirmUsers(),
  });

  const filteredData = useMemo(
    () => data?.filter((user: CustomUser) => user.email?.includes(userSearchValue ?? '')),
    [data, userSearchValue]
  );

  return { data: filteredData, isLoading, error, getFirmUsers };
};

const useGetFirmUsersSlim = (firmId?: number, userSearchValue?: string) => {
  const getFirmUsersSlim = async () => {
    const usersService = new UsersService();
    const firmUsers = await usersService.getUsers(firmId, true);
    if (!firmUsers) throw new Error('An error occurred while retrieving firm users');
    return firmUsers;
  };

  const { data, isLoading, error } = useQuery({
    enabled: !!firmId,
    queryKey: ['firmUsersSlim', firmId],
    queryFn: () => getFirmUsersSlim(),
  });

  const filteredData = useMemo(
    () => data?.filter((user: CustomUser) => user.email?.includes(userSearchValue ?? '')),
    [data, userSearchValue]
  );

  return { data: filteredData, isLoading, error, getFirmUsersSlim };
};

export default useGetFirmUsers;
export { useGetFirmUsersSlim };
